import {
    db,
    serverTimestamp,
} from '../config/firebase';

function setApplicantDetails(applicant) {
    return new Promise((resolve, reject) => {
        const updateCustomer = () => (
            new Promise((resolvePromise, rejectPromise) => {
                const state = {
                    name: applicant.name,
                    surname: applicant.surname,
                    dateOfBirth: applicant.dateOfBirth,
                    phone: applicant.phone,
                    address: applicant.address,
                    lastUpdate: serverTimestamp(),
                };
                const collection = db.collection('customers');
                collection
                    .doc(applicant.customer.uid)
                    .update(state)
                    .then(() => {
                        resolvePromise();
                    })
                    .catch((error) => {
                        rejectPromise(error.message);
                    });
            })
        );
        const updateApplication = () => (
            new Promise((resolvePromise, rejectPromise) => {
                const collection = db.collection('applications');
                collection
                    .doc(applicant.applicationId)
                    .update({
                        'formStepper.activeStep': 4,
                        lastUpdate: serverTimestamp(),
                    })
                    .then(() => {
                        resolvePromise();
                    })
                    .catch((error) => {
                        rejectPromise(error.message);
                    });
            })
        );
        Promise
            .all([
                updateCustomer(),
                updateApplication(),
            ])
            .then(() => {
                resolve();
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export default setApplicantDetails;



// WEBPACK FOOTER //
// ./src/service/setApplicantDetails.js